/* eslint-disable no-loop-func */
import { Box, Typography, useMediaQuery, LinearProgress } from '@mui/material';
import React, { useEffect, useState, useContext } from 'react';
import AuthApis from '../hepler/authApis.service';
import './AccountDiscovery.styles.css';
import AccountDiscoveryContainer from './Discovery/AccountDiscoveryContainer';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material';
import DialogBox from './Dialog Box/Dialog Box';
import VerifyDetailsDOB from './Dialog Box/VerifyDetailsDOB';
import SetTheme from './common/SetTheme';
import { trackEvent } from '../utils/tracking.utils';
import {
	handleFipDiscovery,
	updateAccountDiscoveryState,
} from '../utils/accountDiscovery.utils';
import { areAccountRestrictionsSatisfied } from '../utils/targetedAccounts.utils';
import StepperContext from './Context/StepperContext';
import { useTranslation } from '../hooks/useTranslation';

function AccountDiscovery(props) {
	const { t } = useTranslation();
	const fipExclusionFromJourney = global?.sdkOptions?.fipExclusionFromJourney;
	const { nextStep } = useContext(StepperContext);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	
	// Check for dark theme
	const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const [accountState, setAccountState] = useState({
		isProceed: true,
		discoveredAccounts: [],
		selectedAccounts: [],
		linkedAccounts: [],
		linkedAccountsFull: [],
		isResend: true,
		isLoding: true,
		isDiscovering: false,
		selectedBank: null,
		isSkip: false,
		isDisable: false,
		consentDetails: global.consentList
			? global.consentList
			: props?.location?.state?.data,
		noDiscoveredAccounts: null,
	});
	const [isPanRequired, setIsPanRequired] = useState(
		global?.pan === 'Y' ? false : true
	);
	const [isDobRequired, setIsDobRequired] = useState(
		global?.dob === 'Y' ? false : true
	);
	const [openDOB, setOpenDOB] = useState(false);
	const [dob, setDob] = useState(global?.dob);
	const [pan, setPan] = useState(global?.pan);
	const authApis = new AuthApis();

	useEffect(() => {
		checkIdentifiers();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getLinkedAcc = () => {
		props.updateLoader(false);
		authApis.getLinkedAccounts().then((res) => {
			if (!res) {
				toast.error(t('errors.general.somethingWentWrong'));
				props.updateLoader(false);
			}
			if (res?.status === 'SUCCESS') {
				let linkedacc = res.LinkedAccounts.map((el) => el.accRefNumber);
				let linkedaccFull = res.LinkedAccounts.map((el) => ({
					maskedAccNumber: el.maskedAccNumber,
					FIType: el.FIType,
					accType: el.accType,
					fipId: el.fipId,
					accRefNumber: el.accRefNumber,
				}));

				setAccountState((prevState) => ({
					...prevState,
					linkedAccounts: [...accountState.linkedAccounts, ...linkedacc],
					linkedAccountsFull: [
						...accountState.linkedAccountsFull,
						...linkedaccFull,
					],
				}));
				if (props.match.params.fid) {
					discoverAccount(linkedaccFull);
				} else {
					if (!global.isAddAccount) {
						props.updateLoader(false);
						props.history.push({
							pathname: `/payment-consent`,
							state: { data: res.LinkedAccounts },
						});
						nextStep(2);
					} else {
						discoverAccount();
					}
				}
			} else {
				if (res?.status === 'FAILURE') {
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
					setTimeout(() => {
						props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Consent denied',
								statusCode: 20,
							},
						});
					}, 10000);
				}
				if (props.match.params.fid) {
					discoverAccount();
				} else {
					props.updateLoader(false);
					props.history.push('/payment-consent');
					nextStep(2);
				}
			}
		});
	};

	const getFipIdentifiersInfo = async (fid) => {
		const fipIdentifiers = {};
		const fipIdentifiersTypes = new Set();
		await authApis.fipDetails(fid).then((res) => {
			if (res?.status === 'SUCCESS') {
				res?.FipDetails[0]?.fipFiTypeIdentifiers.forEach((x) => {
					x?.identifiers.forEach((id) => {
						fipIdentifiers[id.type] = id.category;
						fipIdentifiersTypes.add(id.type);
					});
				});
			} else if (
				res?.status === 'FAILURE' &&
				res?.message === 'Session Error.'
			) {
				toast.error(t('errors.session.error'));
			}
		});
		return fipIdentifiers;
	};

	const checkIdentifiers = async () => {
		if (!props.match.params.fid) {
			return getLinkedAcc();
		}
		const fips = props.match.params.fid?.split(',');
		const fipIdentifiersTypes = [];
		for (const fid of fips) {
			fipIdentifiersTypes.push(
				...Object.keys(await getFipIdentifiersInfo(fid))
			);
		}
		if (
			isPanRequired &&
			isDobRequired &&
			fipIdentifiersTypes.includes('DOB') &&
			fipIdentifiersTypes.includes('PAN')
		) {
			setIsDobRequired(true);
			setIsPanRequired(true);
			setOpenDOB(true);
		} else if (isPanRequired && fipIdentifiersTypes.includes('PAN')) {
			setIsPanRequired(true);
			setIsDobRequired(false);
			setOpenDOB(true);
		} else if (isDobRequired && fipIdentifiersTypes.includes('DOB')) {
			setIsDobRequired(true);
			setIsPanRequired(false);
			setOpenDOB(true);
		} else {
			getLinkedAcc();
		}
	};

	const handleDOB = () => {
		setOpenDOB(false);
		getLinkedAcc();
	};

	const discoverAccount = async (linkedaccFull = [], fipId, phoneNumber) => {
		linkedaccFull =
			linkedaccFull.length > 0
				? linkedaccFull
				: accountState.linkedAccountsFull;

		let exclusionList = [];
		try {
			if (fipExclusionFromJourney) {
				exclusionList = JSON.parse(fipExclusionFromJourney);
			}
		} catch (error) {
			console.error('Failed to parse fipExclusionFromJourney:', error);
		}

		const rawFips = fipId ?? props.match.params.fid?.split(',');
		const fips = Array.isArray(rawFips)
			? rawFips.filter((id) => !exclusionList.includes(id))
			: rawFips;

		if (fips.length === 0) {
			props.history.push(
				`/home/?number=${props.match.params?.number}&isAddAccount=${true}`
			);
		}
		phoneNumber = phoneNumber ? phoneNumber : props.match.params.number;

		if (props.match.params.fid?.includes(',')) {
			trackEvent('MULTIPLE_FIP_DISCOVERY', {
				totalFips: fips.length,
				count: fips.length,
			});
		}

		// Create a map to track pending discoveries
		const pendingDiscoveries = new Map();

		// Start all FIP discoveries without waiting
		fips.forEach(async (fid) => {
			try {
				const fipIdentifiersInfo = await getFipIdentifiersInfo(fid);
				const fipData = await handleFipDiscovery({
					fid,
					fipIdentifiersInfo,
					phoneNumber,
					pan,
					dob,
					isPanRequired,
					isDobRequired,
					linkedaccFull,
					authApis,
					pendingDiscoveries,
				});
				setAccountState((prevState) => {
					const updatedState = updateAccountDiscoveryState(
						prevState,
						fipData,
						phoneNumber,
						props.history,
						pendingDiscoveries
					);

					// Check account restrictions satisfaction if they exist
					if (
						global.redirectAccountRestrictions &&
						props?.location?.state?.data &&
						updatedState.linkedAccountsFull
					) {
						const allRestrictionsSatisfied = areAccountRestrictionsSatisfied(
							updatedState.discoveredAccounts,
							updatedState.linkedAccountsFull
						);

						if (allRestrictionsSatisfied && pendingDiscoveries.size === 0) {
							props.history.push(`/payment-consent`);
						}
					}

					return updatedState;
				});
			} catch (error) {
				console.error(`Error in FIP discovery for ${fid}:`, error);
				toast.error(t('errors.general.somethingWentWrong'));
			}
		});
	};

	const handleBack = () =>
		props.history.push(
			`/home/?number=${props.match.params?.number}&isAddAccount=${true}`
		);

	const setTheme = (theme) => {};

	const handleClose = (event, reason) => {
		if (reason && reason === 'backdropClick') {
			return;
		}
		setOpenDOB(false);
		getLinkedAcc();
	};
	useEffect(() => {
		if (props?.updateInitialLoader) {
			props.updateInitialLoader(false);
		}
	}, []);
	return (
		<>
			<SetTheme customDetails={props.customDetails} setTheme={setTheme} />
			{accountState.isDiscovering && (
				<Box
					sx={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						zIndex: 9999,
						backgroundColor: 'white',
					}}
				>
					<LinearProgress
						color="primary"
						sx={{
							height: 4,
							backgroundColor: 'rgba(0, 0, 0, 0.1)',
							'& .MuiLinearProgress-bar': {
								transition: 'transform 0.4s linear',
								backgroundColor: theme.palette.primary.main,
							},
						}}
					/>
				</Box>
			)}
			<Box
				sx={{
					display: 'flex',
					justifyContent: { xs: 'start', md: 'center' },
					flexDirection: { xs: 'column', sm: 'column', md: 'row' },
					minHeight: mobileScreen ? 'auto' : '100vh',
					alignItems: 'start',
					pt: accountState.isDiscovering ? '4px' : 0,
				}}
			>
				{!accountState.isLoding ? (
					<AccountDiscoveryContainer
						{...props}
						setAccountState={setAccountState}
						discoverAccount={discoverAccount}
						accountState={accountState}
						handleBack={handleBack}
					/>
				) : (
					props.match.params.fid && (
						<>
							{!openDOB ? (
																	<Box
										sx={{
											flex: 2,
											display: 'flex',
											alignItems: 'center',
											flexDirection: 'column',
											justifyContent: mobileScreen ? 'center' : 'center',
											minHeight: '100vh',
											minWidth: { xs: '100vw', md: 'auto' },
											background: isDark ? '#161616' : theme.palette.primary.light,
											color: isDark ? '#FFFFFF' : '#000000',
										}}
									>
									<Typography
										sx={{
											fontSize: '1.25rem',
											fontWeight: 900,
											mb: '0.4rem',
											color: isDark ? '#FFFFFF' : '#000000',
										}}
									>
										{t('accountDiscovery.messages.discoveryLoadingHeading')}
									</Typography>
									<Typography
										sx={{
											fontSize: '1rem',
											mb: '1.5rem',
											color: isDark ? '#7A8185' : '#81858F',
										}}
									>
										{t('accountDiscovery.messages.discoveryLoadingSubHeading')}
									</Typography>
									<div className="dots-5"></div>
								</Box>
							) : (
								<Box
									sx={{
										flex: 2,
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										justifyContent: mobileScreen ? 'start' : 'center',
										minHeight: '100vh',
										minWidth: { xs: '100vw', md: 'auto' },
										background: isDark ? '#161616' : theme.palette.primary.light,
										color: isDark ? '#FFFFFF' : '#000000',
										pt: mobileScreen ? '2rem' : 'none',
									}}
								/>
							)}
						</>
					)
				)}
			</Box>
			<DialogBox
				open={openDOB}
				handleClose={handleClose}
				title={t('common.messages.verifyYourDetails')}
				subTitle={t('common.messages.pandDobDetails')}
				boxPadding="1.25rem"
				subTitleMaxWidth="80%"
			>
				<VerifyDetailsDOB
					handleClick={handleDOB}
					date={dob}
					setDate={setDob}
					pan={pan}
					setPan={setPan}
					isPanRequired={isPanRequired}
					isDobRequired={isDobRequired}
				/>
			</DialogBox>
			{accountState.isDiscovering && (
				<Box
					sx={{
						position: 'fixed',
						bottom: 0,
						left: 0,
						right: 0,
						background: isDark ? 'rgba(22, 22, 22, 0.95)' : 'rgba(255, 255, 255, 0.95)',
						color: isDark ? '#FFFFFF' : '#000000',
						padding: '1rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '1rem',
						boxShadow: isDark ? '0 -2px 10px rgba(0, 0, 0, 0.3)' : '0 -2px 10px rgba(0, 0, 0, 0.1)',
						zIndex: 1000,
					}}
				>
					<Typography variant="body2" sx={{ color: isDark ? '#FFFFFF' : 'inherit' }}>
						{t('accountDiscovery.messages.discoveringAccountsFips')}
					</Typography>
					<Box
						sx={{
							width: 20,
							height: 20,
							border: '2px solid #f3f3f3',
							borderTop: '2px solid #3498db',
							borderRadius: '50%',
							animation: 'spin 1s linear infinite',
							'@keyframes spin': {
								'0%': { transform: 'rotate(0deg)' },
								'100%': { transform: 'rotate(360deg)' },
							},
						}}
					/>
				</Box>
			)}
		</>
	);
}

export default AccountDiscovery;
